import React, { useEffect, useState } from 'react';
import LinkPlus from '../UI/LinkPlus.js';
import MensajeCargando from '../UI/MensajeCargando.js';
import MensajeError from '../UI/MensajeError.js';
import Paginador from '../UI/Paginador.js';
import TablaDatos from '../UI/TablaDatos.js';
import * as UI from '../constantes/UI.js';
import * as Data from '../data/DataPersonas.js';
import { NombreEquipoCategoria } from '../funciones/FuncionesEquipo.js';
import * as Fecha from '../funciones/FuncionesFecha.js';
import { TextoTiempo } from '../funciones/FuncionesPartidos.js';
import useGetListaURL from '../../hooks/useGetListaURL.js';
import styles from './TablaGolesPersona.module.css';

const TablaGolesPersona = (props) => {
  const [goles, setGoles] = useState(null);
  const [cantPaginas, setCantPaginas] = useState(null);
  const [pagina, setPagina] = useState(0);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();
  const idPersona = props.persona && props.persona.id;
  const { GOLES_X_PAGINA } = UI.useUI();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    const getTotalGoles = async () => {
      let total = await Data.GetTotalGolesJugador(idPersona);
      if (total !== null && total !== Promise.resolve(total)) {
        setCantPaginas(Math.floor(total / GOLES_X_PAGINA) + 1);
      }
    };
    if (idPersona !== null) {
      getTotalGoles();
    }
  }, [fetchData, idPersona, GOLES_X_PAGINA]);

  useEffect(() => {
    if (idPersona === null) {
      setGoles(null);
    } else {
      fetchData(
        'personas/' + idPersona + '/goles?pagina=' + pagina + '&items=' + GOLES_X_PAGINA,
        setGoles
      );
    }
  }, [fetchData, idPersona, pagina, GOLES_X_PAGINA]);

  const onPaginaElegida = (pagina) => {
    setPagina(pagina);
  };

  return (
    <React.Fragment>
      {goles && !isCargando && (
        <React.Fragment>
          <TablaDatos
            estilo={`${styles.tablaGoles}`}
            lista={goles}
            textoVacia="No hay goles cargados para la persona"
          >
            <tbody>
              <tr className={`${styles.titulo}`} key="0">
                <td className={`${styles.fecha}`}>Fecha</td>
                <td className={`${styles.torneo}`}>Torneo</td>
                <td className={`${styles.equipo}`}>Equipo</td>
                <td className={`${styles.rival}`}>Rival</td>
                <td className={`${styles.resultado}`}>Res.</td>
                <td className={`${styles.tiempo}`}>Tiempo</td>
              </tr>
              {goles.map((gol) => (
                <tr key={gol.id}>
                  <td>
                    {Fecha.CamposToFechaCorta(gol.anioPartido, gol.mesPartido, gol.diaPartido)}
                  </td>
                  <td>{gol.motivo}</td>
                  <td>
                    {NombreEquipoCategoria(
                      gol.equipo.nombre,
                      gol.equipo.categoria,
                      gol.categoriaPartido
                    )}
                  </td>
                  <td>
                    {NombreEquipoCategoria(
                      gol.rival.nombre,
                      gol.rival.categoria,
                      gol.categoriaPartido
                    )}
                  </td>
                  <td>
                    <LinkPlus to={'/partido/' + gol.idPartido} adaptativo={true}>
                      {gol.resultadoEquipo + ' - ' + gol.resultadoRival}
                    </LinkPlus>
                  </td>
                  <td className={`${styles.tiempo}`}>{TextoTiempo(gol.tiempo, gol.minutos)}</td>
                </tr>
              ))}
            </tbody>
          </TablaDatos>
          <Paginador
            cantPaginas={cantPaginas}
            cantBotones="5"
            paginaActual={pagina}
            onPaginaElegida={onPaginaElegida}
          />
        </React.Fragment>
      )}
      <MensajeCargando estilo={`${styles.cargando}`} isCargando={isCargando} />
      <MensajeError estilo={`${styles.error}`} errores={erroresGetLista} />
    </React.Fragment>
  );
};

export default TablaGolesPersona;
